<template>
  <div class="w-full overflow-auto bg-n-background">
    <div
      class="flex flex-col w-full max-w-6xl gap-4 px-4 pt-6 pb-12 mx-auto md:px-6"
    >
      <router-view />
    </div>
  </div>
</template>
